import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const StyledBoxOnHover = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  boxShadow: 'none',
  transition: theme.transitions.create(['box-shadow'], {
    duration: theme.transitions.duration.standard,
  }),
  '&:hover': {
    boxShadow: '0 15px 40px rgba(10, 14, 18, .1)',
  },
}));

export default StyledBoxOnHover;
